import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

const ACTIONS = createAsyncActions('SERVER.VOD-SETTINGS.UPDATE');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function (settings) {
  return function (dispatch, getState) {
    const { vodSettings } = getState();

    if (_.isEmpty(settings)) {
      return Promise.resolve(vodSettings);
    }

    if (_.isEqual(settings, vodSettings)) {
      return Promise.resolve(vodSettings);
    }

    settings = _.merge({}, vodSettings, settings);

    dispatch(START(settings));

    return vodAdapter.settings.update(settings)
      .then(
        function (result) {
          dispatch(SUCCESS(settings, result));
          return result;
        },

        function () {
          dispatch(FAIL(settings, null, { analytics: { type: 'error', name: 'shared.vod-settings.update' } }));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/vod-settings/update.js